import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FormatePrice } from '../../utils/FormatePrice.jsx';
import { Spin, Carousel, message } from 'antd';
import PropertyDetailsList from "../../JsonData/property-details.json"
import "../../utils/propertyDetailsImgScrol.css"
import SimilarProperty from './property-similar';
import { slugify } from '../../utils/slugify';
import sectiondata from "../../data/sections.json"
import { SendMail } from '../../request/apiRquest';
import Cta from '../../utils/CtaForProperties';
// import AmenitiesSection from '../../utils/propertyAmenities';
import PropertySummary from '../new-components/propertySummary';
import Pricing from './pricing';
import BrochureDownload from '../../utils/BrochureDownload';
import BrochurePropertyDetails from '../../utils/BrochurePorpetyDetails';
import DeveloperMain from '../Developers/developerMain';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import PropertiesFaqs from './propertiesFaqs';



const PropertyDetails = () => {


  message.config({
    top: 100,
    //	duration: 2, 
  });


  const { propertySlug } = useParams();
  // console.log(property?.building_type, "00000000000000");

  let Testimonialdata = sectiondata.Testimonial

  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 550;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  //console.log(property?.description?.richtext === "" , "##############`");


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  }

  const shortDescription =
    property?.description?.length > maxLength && !isExpanded
      ? `${property?.description?.slice(0, maxLength)}...`
      : property?.description;


  let imagealt = 'image'
  const images = property?.images || [];

  const handleAllImagesLoaded = () => {
    let imagesToLoad = images.length;
    let loadedCount = 0;

    if (imagesToLoad === 0) {
      setImagesLoaded(true);
      return;
    }

    images.forEach((imgObj) => {
      const img = new Image();
      img.src = imgObj?.src;

      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === imagesToLoad) {
          setImagesLoaded(true);
        }
      };

    });
  };

  useEffect(() => {
    const foundProperty = PropertyDetailsList.PropertyDetailsList.find(
      (prop) => slugify(prop.PropertyName) === propertySlug
    );

    setProperty(foundProperty);
    setLoading(false);
  }, [propertySlug]);

  useEffect(() => {

    if (property && property.images) {

      setTimeout(() => {
        handleAllImagesLoaded();
      }, 700)
    }
    setLoading(false);
    console.log(property?.images, "nameeeeeeeee");

  }, [property, isExpanded]);


  const [maildata, setMailData] = useState({
    FromName: "",
    FromEmail: "",
    ContactNo: "",
    Message: "",
    Language: ""
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)

    if (!maildata?.ContactNo && !maildata?.FromEmail) {
      message.warning("Please fill the contact details before submitting");
      setLoading(false);
    } else {

      try {
        //console.log(maildata, "submit data");

        await SendMail(maildata);
        message.success("Your message has been sent successfully!", 3)
        setMailData({
          FromName: "",
          FromEmail: "",
          ContactNo: "",
          Message: "",
        });
      } catch (error) {
        console.log(error);
        message.error("Failed to send your message. Please try again.", 4);
      } finally {
        setLoading(false);
      }
    }
  }

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setMailData({ ...maildata, [name]: value });
  }




  if (loading || !imagesLoaded) {
    return (<div className="text-center py-5">
      <Spin className="custom-orange-spin" size="large" tip="Loading properties..." />
    </div>)
    //<div className='col-12'> <p>Loading....</p></div>;
  }
  //console.log(propertices);

  if (!property) {
    return <div className='col-12'><p>No property details available</p></div>;
  }

  return (

    <div className="property-details-area">
      <div className="bg-gray pd-top-0 pd-bottom-30">
        <div className="container" style={{ padding: "40px 0" }}>

          {/* 🔹 New Row at Top — Image Gallery */}
          <div
            className="row"
            style={{
              marginBottom: "50px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-start",
            }}
          >
            {/* Left: Main Image */}
            <div
              className="col-12 col-md-9"
              style={{
                flex: "1 1 100%",
                marginBottom: "15px",
              }}
            >
              <img
                src={selectedImg ? selectedImg.src : images[1].src}
                alt={imagealt}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "500px",
                  objectFit: "cover",
                  borderRadius: "14px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}
              />
            </div>

            {/* Right: Thumbnails */}
            <div
              className="col-12 col-md-3 thumbnail-wrapper"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "10px",
                overflowX: "auto",
                justifyContent: "center",
              }}
            >
              {images.slice(1).map((image, index) => (
                <img
                  key={index}
                  src={image.src}
                  alt={`thumbnail-${index}`}
                  style={{
                    width: "100px",
                    height: "90px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    cursor: "pointer",
                    border:
                      selectedImg?.src === image.src
                        ? "3px solid #FEA928"
                        : "1px solid #ccc",
                    transition: "0.3s ease",
                    boxShadow:
                      selectedImg?.src === image.src
                        ? "0 0 12px rgba(254,169,40,0.4)"
                        : "0 2px 8px rgba(0,0,0,0.05)",
                  }}
                  onClick={() => setSelectedImg(image)}
                />
              ))}
            </div>
          </div>

          {/* === ROW 1: Property Title, Developer, Price & Button === */}
          <div
            className="row align-items-center"
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              marginBottom: "40px",
              gap: "20px",
            }}
          >
            <div className="col-12 col-md-7" style={{ flex: "1 1 100%" }}>
              <h2
                style={{
                  fontWeight: 700,
                  color: "#002061",
                  fontSize: "clamp(26px, 4vw, 38px)",
                  marginBottom: "5px",
                }}
              >
                {property.PropertyName}
              </h2>

              <h4
                style={{
                  color: "#777",
                  marginBottom: "10px",
                  fontSize: "clamp(16px, 2vw, 18px)",
                }}
              >
                By{" "}
                <Link
                  to={`/developername/dubai/${slugify(property.DeveloperName)}`}
                  style={{ color: "#002061", fontWeight: "600", cursor: "pointer" }}
                >
                  <u>

                    {property.DeveloperName.toUpperCase()}
                  </u>
                </Link>
              </h4>

              <h2
                style={{
                  fontWeight: "800",
                  color: "#002061",
                  fontSize: "clamp(28px, 5vw, 48px)",
                  marginTop: "0px",
                  letterSpacing: "-0.5px",
                }}
              >
                {FormatePrice(property.price ?? 0)} AED
              </h2>
            </div>

            <div
              className="col-12 col-md-4"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* <button
          style={{
            background:
              "linear-gradient(90deg, #FEA928 0%, #FFBF57 100%)",
            color: "#fff",
            border: "none",
            padding: "15px 40px",
            borderRadius: "12px",
            fontWeight: "600",
            fontSize: "clamp(14px, 2vw, 17px)",
            cursor: "pointer",
            boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
            transition: "all 0.3s ease",
            width: "100%",
            maxWidth: "280px",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(90deg, #fda94f 0%, #fda94f 100%)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(90deg, #fda94f 0%, #fda94f 100%)")
          }
        >
          <i className="fa fa-download" style={{ marginRight: "10px" }}></i>
          Download Brochure
          <BrochureDownload download_link={property.Brochure} />
        </button> */}
              <BrochurePropertyDetails download_link={property.Brochure} />
            </div>
          </div>

          {/* === ROW 2: Building Type + Address === */}
          <div
            className="row"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              marginBottom: "40px",
            }}
          >
            {[{
              title: "Building Type",
              icon: "fa-home",
              value: property.building_type ?? "N/A",
            },
            {
              title: "Address",
              icon: "fa-map-marker",
              value: property.locality_Address ?? "N/A",
            }].map((item, index) => (
              <div
                key={index}
                style={{
                  flex: "1 1 48%",
                  minWidth: "280px",
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "20px 24px",
                  boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#002061",
                    marginBottom: "6px",
                  }}
                >
                  {item.title}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    wordBreak: "break-word",
                  }}
                >
                  <i
                    className={`fa ${item.icon}`}
                    style={{
                      color: "#FEA928",
                      marginRight: "8px",
                      fontSize: "18px",
                    }}
                  ></i>
                  {item.value}
                </div>
              </div>
            ))}
          </div>

          {/* === ROW 3: Bedrooms / Area / Parking === */}

          <div
            className="row"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              marginBottom: "40px",
            }}
          >
            {[
              {
                title: "Bedrooms",
                icon: "fa-bed",
                value: property.number_bedroom,
              },
              {
                title: "Area",
                icon: "fa-expand",
                value: `${property.builtup_area}`,
              },
              ...(property.coverd_parking && property.open_parking
                ? [
                  {
                    title: "Parking",
                    icon: "fa-car",
                    value: `${property.coverd_parking} Covered & ${property.open_parking} Open`,
                  },
                ]
                : []),
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  flex: "1 1 30%",
                  minWidth: "280px",
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "20px 24px",
                  boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#002061",
                    marginBottom: "6px",
                  }}
                >
                  {item.title}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    wordBreak: "break-word",
                  }}
                >
                  <i
                    className={`fa ${item.icon}`}
                    style={{
                      color: "#FEA928",
                      marginRight: "8px",
                      fontSize: "18px",
                    }}
                  ></i>
                  {item.value}
                </div>
              </div>
            ))}
          </div>


          {/* === ROW 4: Property Summary === */}
          <div className="row" style={{ marginBottom: "40px" }}>
            <div className="col-12">
              <PropertySummary property={property} />
            </div>
          </div>

          {/* === ROW 5: Pricing === */}
          <div className="row">
            <div className="col-12">
              <Pricing property={property} />
            </div>
          </div>
        </div>
      </div>


      <div className="container">
        <div className="row pd-top-70">
          <div className="col-lg-8">



            {property?.description?.richtext !==
              "" && <div className="property-news-single-card style-two border-bottom-yellow">



                <h1 style={{ fontSize: isMobile ? "25px" : "35px", paddingBottom: "20px" }} dangerouslySetInnerHTML={{
                  __html:
                    property.descriptionH1.richtext
                }}
                ></h1>
                <div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        property?.description?.richtext?.length > maxLength && !isExpanded
                          ? `${property.description.richtext.slice(0, maxLength)}...`
                          : property.description.richtext
                    }}
                  />
                  {property?.description?.richtext?.length > maxLength && (
                    <button

                      onClick={toggleReadMore}
                      style={{ color: "#FDA94F", cursor: "pointer", background: "none", border: "none", justifyContent: "spacearound" }}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  )}
                </div>

                {/* <a href="#">Read More</a> */}
                {property.Highlights?.length > 0 && (
                  <>
                    <h2 style={{ fontSize: "25px" }}>Key Highlights:</h2>
                    <ul>
                      {property?.Highlights?.map((pt, index) => {
                        const value = Object.values(pt)[0];
                        return <li key={index}>{value}</li>;
                      }

                      )}
                    </ul>
                  </>
                )

                }


                {property?.propertyCta && <Cta
                  propertyCta={property.propertyCta}
                />}

              </div>}




            <div className="property-news-single-card style-two border-bottom-yellow">
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                // alignItems: 'center',
              }}>
                <h4 >Location</h4>
                <h4 style={{ color: '#555', fontSize: "17px", fontWeight: "500" }}>{property.locality_Address}</h4>
              </div>
              <iframe
                src={`https://www.google.com/maps?q=${property.latitude},${property.longitude}&hl=es;z=14&output=embed`}
                style={{ border: 0, }} allowFullScreen
              />
            </div>


            {/* <div className="col-md-3 col-sm-6">
                <div className="single-floor-list media">
                  <div className="media-left">
                    <i className="fa fa-bath" />
                  </div>
                  <div className="media-body">
                    <h6>Bathroom</h6>
                    <p>20 x 16 sq feet</p>
                  </div>
                </div>
              </div> */}


          </div>

          <div className="col-xl-4 col-lg-4">
            <div className="widget widget-owner-info mt-lg-0 mt-5">

              <div className="owner-info text-center">
                {/* <div className="thumb">
                <img src={ publicUrl+"/assets/img/news/21.png"} alt={ imagealt } />
              </div> */}
                <div className="details">
                  <h6>Contact Us</h6>
                  <span className="designation">TrinestSky Real Estate Dubai.</span>
                  <p className="reviews"><i className="fa fa-star" /><span>5.0</span>{Testimonialdata?.items.length} Review</p>
                </div>
              </div>

              {/* <h6>Contact Us</h6> */}
              <form className="contact-form-wrap contact-form-bg">
                {/* <h4>Send Us a Message</h4> */}
                <p>Fill out the form below and our team will respond within 24 hours.</p>
                <div className="rld-single-input">
                  <input type="text" value={maildata.FromName} placeholder="Name" name="FromName" onChange={handleChangeInput} />
                </div>

                <div className="rld-single-input">
                  <input type="email" value={maildata.FromEmail} placeholder="Email" name="FromEmail" onChange={handleChangeInput} />
                </div>

                <div className="rld-single-input">
                  <input type="number" value={maildata.ContactNo} placeholder="Contact Number" name="ContactNo" onChange={handleChangeInput} />
                </div>

                <div className="rld-single-input">
                  <select
                    name="Language"
                    value={maildata.Language}
                    onChange={handleChangeInput}
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      fontSize: "15px",
                      color: "#333",
                      backgroundColor: "#f3f3f3",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      outline: "none",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      backgroundImage:
                        "url(\"data:image/svg+xml;utf8,<svg fill='gray' height='16' viewBox='0 0 24 24' width='16' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 12px center",
                      backgroundSize: "24px",
                      boxSizing: "border-box"
                    }}
                  >
                    <option value="">Select Language</option>
                    <option value="English">English</option>
                    <option value="Arabic">Arabic</option>
                    <option value="Hindi">Hindi</option>
                  </select>
                </div>

                <div className="rld-single-input">
                  <textarea rows={10} name="Message" value={maildata.Message} placeholder="Message" onChange={handleChangeInput} defaultValue={""} />
                </div>

                <div className="btn-wrap text-center">
                  <button className="btn btn-yellow" type="submit" onClick={handleSubmit} disabled={loading}>{loading ? "Submiting..." : "Submit"}</button>
                </div>

                {/*<div><p style={{fontSize:"10px",paddingTop:"10px"}}>By clicking Submiting,you agree to our Terms & Conditions and Privacy Policy. </p></div> */}
              </form>


              <div className="contact-info">
                <h6 className="mb-3">Contact Info</h6>
                <div className="media">
                  <div className="media-left">
                    {/* <img src={ publicUrl+"/assets/img/icons/1.png"} alt={ imagealt } /> */}
                  </div>
                  <div className="media-body">
                    <p>Address</p>
                    <span>Aspin Commercial Tower
                      - 4302F <br></br>
                      -106 Sheikh Zayed Rd <br></br>
                      -Trade Centre-Trade Centre 1 <br></br>
                      - Dubai</span>
                  </div>
                </div>
                <div className="media">
                  <div className="media-left">
                    <i className="fa fa-phone" />
                  </div>
                  <div className="media-body">
                    <p>Phone</p>
                    <span>056 860 0147</span>
                  </div>
                </div>
                <div className="media mb-0">
                  <div className="media-left">
                    <i className="fa fa-envelope" />
                  </div>
                  <div className="media-body">
                    <p>Email</p>
                    <span>ifo@trinestsky.com</span><br></br>
                    <span>sr@trinestsky.com</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* < Pricing/> */}
        </div>
      </div>

      <div className='pd-top-30'>
        <PropertiesFaqs
          propertyId={property.Property_ID}
        />
      </div>
    </div >
  )



}

export default PropertyDetails